 /* eslint-disable */ 
 let tag= process.env.VUE_APP_TAG
 let new_service_basis=getEnv(tag).service_basis

export default {
  // 课程实训接口
  /**
   * 查询课程实训下我的项目列表
   */
  getMyProjectList: `${new_service_basis}/ai/training/curriculum/getMyProjectList`,
  /**
   * 学生查询课程实训下我的项目列表
   */
  getProjectListByStudentId: `${new_service_basis}/ai/training/curriculum/getProjectListByStudentId`,
  /**
   * 创建课程实训
   */
  insertCurriculum: `${new_service_basis}/ai/training/curriculum/insertCurriculum`,
  /**
   * 修改课程实训
   */
  updateCurriculum: `${new_service_basis}/ai/training/curriculum/updateCurriculum`,
  /**
   * 删除课程实训
   */
  deleteCurriculum: `${new_service_basis}/ai/training/curriculum/deleteCurriculum`,
  /**
   * 根据课程id查询课程信息
   */
  getCurriculumInfoByCurriculumId: `${new_service_basis}/ai/training/curriculum/getCurriculumInfoByCurriculumId`,
  /**
   * 置顶课程实训
   */
  topCurriculum: `${new_service_basis}/ai/training/curriculum/topCurriculum`,
  /**
   * 复制课程
   */
  copyCurriculum: `${new_service_basis}/ai/training/curriculum/copyCurriculum`,

  /**
   * 根据课程id查询租户关联信息
   */
  getTenantRelationByCurriculumId: `${new_service_basis}/ai/training/curriculum/getTenantRelationByCurriculumId`,
  /**
   * 根据课程id查询租户列表
   */
  getTenantByCurriculumId: `${new_service_basis}/ai/training/curriculum/getTenantByCurriculumId`,
  /**
   * 保存课程与租户的关联关系
   */
  saveCurriculumAndTenant: `${new_service_basis}/ai/training/curriculum/saveCurriculumAndTenant`,
  /**
   * 根据关联id删除租户关联关系
   */
  deleteRelationByRelationId: `${new_service_basis}/ai/training/curriculum/deleteRelationByRelationId`,
  /**
   * 根据关联id批量删除租户关联关系
   */
  batchDeleteRelationByRelationId: `${new_service_basis}/ai/training/curriculum/batchDeleteRelationByRelationId`,

  /**
   * 查看课程关联的用户列表
   */
  getUserListByCurriculumId: `${new_service_basis}/ai/training/curriculum/getUserListByCurriculumId`,
  /**
   * 查询当前用户所在组织的学生
   */
  getStudentByCurrentUser: `${new_service_basis}/ai/training/curriculum/getStudentByCurrentUser`,
  /**
   * 课程关联学生
   */
  saveCurriculumAndStudent: `${new_service_basis}/ai/training/curriculum/saveCurriculumAndStudent`,
  /**
   * 单个删除课程关联的用户
   */
  deleteCurriculumUser: `${new_service_basis}/ai/training/curriculum/deleteCurriculumUser`,
  /**
   * 批量删除课程关联的用户
   */
  batchDeleteCurriculumUser: `${new_service_basis}/ai/training/curriculum/batchDeleteCurriculumUser`,


  // 实训目录接口
  /**
   * 查询实训目录列表数据(老师)
   */
  getTrainingListByCurriculumId: `${new_service_basis}/ai/training/training/getTrainingListByCurriculumId`,
  /**
   * 查询实训目录列表数据(学生)
   */
  getTrainingListByCurriculumIdStu: `${new_service_basis}/ai/training/training/getTrainingListByCurriculumIdStu`,
  /**
   * 根据实训目录id查询实训信息
   */
  getTrainingByTrainingId: `${new_service_basis}/ai/training/training/getTrainingByTrainingId`,
  /**
   * 根据实训课程id查询实训模型项目
   */
  getTagTrainingByCurriculumId: `${new_service_basis}/ai/training/training/getTagTrainingByCurriculumId`,

  /**
   * 创建实训项目
   */
  insertTraining: `${new_service_basis}/ai/training/training/insertTraining`,
  /**
   * 复制实训项目
   */
  copyTraining: `${new_service_basis}/ai/training/training/copyTraining`,
  /**
   * 修改实训项目
   */
  updateTraining: `${new_service_basis}/ai/training/training/updateTraining`,
  /**
   * 删除实训项目
   */
  deleteTraining: `${new_service_basis}/ai/training/training/deleteTraining`,
  /**
   * 发布/撤回发布实训项目
   */
  releaseTraining: `${new_service_basis}/ai/training/training/releaseTraining`,
  /**
   * 查询实训项目被引用的实训模型
   */
  getQuoteCountByTrainingId: `${new_service_basis}/ai/training/training/getQuoteCountByTrainingId`,

  /**
   * 上传实训任务书
   */
  uploadTrainingTask: `${new_service_basis}/ai/training/training/uploadTrainingTask`,
  /**
   * 上传实训指导书
   */
  uploadTrainingGuidance: `${new_service_basis}/ai/training/training/uploadTrainingGuidance`,
  /**
   * 删除实训任务书
   */
  deleteTrainingTask: `${new_service_basis}/ai/training/training/deleteTrainingTask`,
  /**
   * 删除实训指导书
   */
  deleteTrainingGuidance: `${new_service_basis}/ai/training/training/deleteTrainingGuidance`,
  /**
   * 学生查询其它项目列表数据
   */
  getOtherTrainingByCurriculumId: `${new_service_basis}/ai/training/training/getOtherTrainingByCurriculumId`,
  /**
   * 获取项目解法
   */
  getProjectExplanation: `${new_service_basis}/ai/training/project/getProjectExplanation`,
  /**
   * 获取项目题面
   */
  getProjectQuestion: `${new_service_basis}/ai/training/project/getProjectQuestion`,
  /**
   * 学生发布项目解法
   */
  releaseProjectExplanation: `${new_service_basis}/ai/training/project/releaseProjectExplanation`,
  /**
   *  查询实训项目编辑方式
   */
  getTrainingType: `${new_service_basis}/ai/training/training/getTrainingType`,

  /**
   * 根据租户查询实训项目类型
   */
  getProjectType: `${new_service_basis}/ai/training/training/getProjectType`,
}
